<div class="stickyCarousel container-fluid">
  <div id="carouselExample" class="carousel slided-non" data-ride="carousel">
    <div class="container">


      <div class="carousel-inner" role="option">


        @for (eventGroup of eventGroups; track eventGroup; let i = $index) {
          <div class="carousel-item" [ngClass]="{ 'active': i === 0 }">
            <div class="event-cont">
              @for (event of eventGroup; track event) {
                <div class="h-card">
                  @if (event.imageUrl) {
                    <div class="img-cont">
                      <img [src]="event.imageUrl"
                        class=" circle clickable"
                        alt="Events Flyer"
                        data-bs-toggle="modal"
                        data-bs-target="#imageModal"
                        (click)="openImageModal(event.imageUrl)" />
                      </div>
                    }
                    @if (!event.imageUrl) {
                      <div class="img-cont">
                        <img src="../../../assets/images/calendar.jpg"
                          class=" circle clickable"
                          alt="Events Flyer"
                          />
                        </div>
                      }
                      <div class="h-card-body">
                        <div class="main-info t-center start-date">
                          <h2 class="dark-red title-color mt-2 t-center">{{ event.title }}</h2>
                          <!-- <p>{{ event.description }}</p> -->
                          <p >
                            {{ event.startDate | date : "MM/dd/yyyy" }}
                            @if (event.endDate) {
                              <span>
                                -
                                {{ event.endDate | date : "MM/dd/yyyy" }}
                              </span>
                            }
                          </p>
                          <p >Location : {{ event.location }}</p>
                        </div><!-- end start date -->
                      </div> <!-- end card body -->
                      @if (event.registrationUrl) {
                        <a class="cta"  href="{{ event.registrationUrl }}"
                          title="{{ event.registrationLinkText }}" target="_blank">
                        {{ event.registrationLinkText }}</a>
                      }
                      <!-- <a class="btn webBtn" title="View Flyer" href="{{ event.imageUrl }}" target="_blank">
                    View Flyer</a> -->
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
